export const INITIAL_STATE = {
    data: {
        total: 0,
        callSessions: [],
        current: 0,
        next: 0,
    },
    isLoading: false,
};
